import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import TextField from "material-ui/TextField";
import { FormLabel, FormControl } from "material-ui/Form";
import Switch from "material-ui/Switch";
import ModalFormDialog from "./ModalFormDialog";

const styles = theme => ({
  root: {
    background: theme.palette.background.paper
  },
  paper: {
    margin: "auto",
    maxWidth: 600
  },
  appBar: {
    height: 64,
    backgroundColor: theme.palette.primary[600]
  },
  title: {
    flex: 1,
    color: theme.palette.background.appBar
  },
  inner: {
    margin: "64px 80px 0",
    height: "100%",
    minWidth: 280
  },
  textField: {
    width: "100%"
  },

  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  radioForm: {
    marginTop: 24,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  radioLabel: {
    width: 160,
    color: "rgba(0,0,0,0.4)"
  },

  dateFieldsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  dateField: {
    flex: 1,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 150
  },

  labels: {
    color: "rgba(0,0,0,0.4)"
  }
});

class EditAccountSettingsDialog extends Component {
  constructor(props) {
    super(props);
    this.handleUseLimitsToggle = this.handleUseLimitsToggle.bind(this);
    this.handleMaxInstancesChange = this.handleMaxInstancesChange.bind(this);
    this.handleMaxSyncersChange = this.handleMaxSyncersChange.bind(this);
  }

  handleUseLimitsToggle(event, checked) {
    this.props.onChange({ useLimits: checked });
  }

  handleMaxInstancesChange(event) {
    this.props.onChange({ maxInstances: event.target.value });
  }

  handleMaxSyncersChange(event) {
    this.props.onChange({ maxSyncers: event.target.value });
  }

  handleChargeThresholdChange(event) {
    this.props.onChange({ chargeThreshold: event.target.value });
  }

  render() {
    let { classes, accountSettings } = this.props;

    return (
      <div>
        <ModalFormDialog
          title="Edit Account Settings"
          open={this.props.open}
          onCancel={this.props.onCancel}
          onSave={this.props.onSave}
        >
          <FormControl className={classes.radioForm}>
            <FormLabel className={classes.radioLabel}>Limit usage</FormLabel>

            <Switch
              checked={accountSettings.useLimits}
              onChange={this.handleUseLimitsToggle}
            />
          </FormControl>
          <TextField
            id="instances"
            label="Max instances"
            type="number"
            min={1}
            value={accountSettings.maxInstances}
            className={classes.textField}
            disabled={!accountSettings.useLimits}
            margin="normal"
            onClick={evt => this.handleUseLimitsToggle(evt, true)}
            onChange={evt => this.handleMaxInstancesChange(evt)}
            inputProps={{ min: 1 }}
            InputLabelProps={{ className: classes.labels }}
          />
          <TextField
            id="syncers"
            label="Max syncers"
            type="number"
            min={2}
            value={accountSettings.maxSyncers}
            className={classes.textField}
            disabled={!accountSettings.useLimits}
            margin="normal"
            onClick={evt => this.handleUseLimitsToggle(evt, true)}
            onChange={evt => this.handleMaxSyncersChange(evt)}
            inputProps={{ min: 2, placeholder: 2 }}
            InputLabelProps={{ className: classes.labels }}
          />
          <TextField
            id="chargeThreshold"
            label="Charge Threshold"
            type="number"
            min={1}
            value={accountSettings.chargeThreshold}
            className={classes.textField}
            disabled={!accountSettings.useLimits}
            margin="normal"
            onClick={evt => this.handleUseLimitsToggle(evt, true)}
            onChange={evt => this.handleChargeThresholdChange(evt)}
            inputProps={{ min: 1, placeholder: 500 }}
            InputLabelProps={{ className: classes.labels }}
          />
        </ModalFormDialog>
      </div>
    );
  }
}

EditAccountSettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default withStyles(styles, { name: "EditAccountSettingsDialog" })(
  EditAccountSettingsDialog
);



// WEBPACK FOOTER //
// ./src/EditAccountSettingsDialog.js